module.exports = __webpack_public_path__ + "img/refresh.0c8a340d.svg";